module.exports = __webpack_public_path__ + "img/energise.e46e7573.svg";